import React from 'react';
export const SpaceContext = React.createContext({
    latestIndex: 0,
    horizontalSize: 0,
    verticalSize: 0,
    supportFlexGap: false,
});
export const SpaceContextProvider = SpaceContext.Provider;
